<template>
    <div>
        <div>
            <vue-headful :title="$t('title_store')" description="title" />
        </div>
        <v-container fluid fill-height>
            <v-row class="mx-12 mt-12">
                <TopBar />
                <TabSelector class="mt-0 mt-lg-6" v-on:new-tab="setTab" v-on:search="setSearch" />
                <Tabs class="px-0" :search="search" :tabSelected="tabSelected" />
            </v-row>
        </v-container>
    </div>
</template>
<script>
import Tabs from '@/components/store/Tabs.vue'
import TabSelector from '@/components/store/TabSelector.vue'
import TopBar from '@/components/home/TopBar.vue'

export default {
    components: {
        Tabs,
        TabSelector,
        TopBar
    },
    data() {
        return {
            search: '',
            tabSelected: 0
        }
    },
    mounted() {
        window.ChurnZero.push(['trackEvent', 'store', 'Go to Store']);
    },
    methods: {
        setSearch(data) {
            this.search = data.trim()
        },
        setTab(data) {
            this.tabSelected = data
        }
    }
}
</script>